<template>
  <div class="main-body">
    <!-- モーダル部 -->
    <ModalCreateTask
      :isShowModal="isModalCreateTask"
      :user="user"
      @cancel="changeCreateTaskView"
      @createUserTask="createUserTask"
      v-if="isModalCreateTask"
    />
    <ModalEditTask
      :isShowModal="isModalEditTask"
      :editTask="editTask"
      :isFileChanging="isFileChanging"
      @cancel="changeEditTaskView"
      @updateUserTask="updateUserTask"
      @createUserTaskFile="createUserTaskFile"
      @deleteUserTaskFile="deleteUserTaskFile"
      v-if="editTask"
    />
    <ModalSendTask
      :isShowModal="isModalSendTask"
      :sendTask="sendTask"
      :users="users"
      @cancel="changeSendTaskView"
      @sendUserTask="sendUserTask"
      v-if="sendTask"
    />
    <ModalDeleteTask
      :isShowModal="isModalDeleteTask"
      :deleteTask="deleteTask"
      @cancel="changeDeleteTaskView"
      @deleteUserTask="deleteUserTask"
      v-if="deleteTask"
    />
    <ModalTaskLog
      :isShowModal="isModalTaskLog"
      :taskList="taskList"
      :users="users"
      @cancel="changeModalTaskLog"
      v-if="isModalTaskLog"
    />
    <ModalLinkTrello
      :isShowModal="isModalLinkTrello"
      :taskList="taskList"
      :user="user"
      @cancel="changeModalLinkTrello"
      @createLinkTrelloAPI="createLinkTrelloAPI"
      @createLinkTrelloBoard="createLinkTrelloBoard"      
      v-if="isModalLinkTrello"
    />
    <!-- タスク用 -->
    <IslandTask
      :isTaskList="isTaskList"
      :taskList="taskList"
      :trelloBoardList="trelloBoardList"
      :trelloListList="trelloListList"
      :trelloCardList="trelloCardList"        
      @changeEditTaskView="changeEditTaskView"
      @changeDeleteTaskView="changeDeleteTaskView"
      @createEvent="createEvent"
      @changeSendTaskView="changeSendTaskView"
      @changeCreateTaskView="changeCreateTaskView"
      @changeModalTask="changeModalTask"
      @changeModalTaskLog="changeModalTaskLog"
      @changeModalLinkTrello="changeModalLinkTrello"
      @updateUserTaskLog="updateUserTaskLog"
    />
    <!-- ヘッダー -->
    <div class="header-box" :class="{'header-ontask': isTaskList}">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">List</b></p>
        <div style="margin-left: 25px; font-size:16px; color: #666;">
          <p style="text-align: left;">タスク予定リスト</p>
          <div style="display: flex;">
            <p style="padding-left: 3px; font-size: 12px;">{{getRenkei()}}</p>
            <a @click="openSettings()" style="padding-left: 3px; font-size: 12px; margin-left: 8px; z-index: 2;"
            v-if="getRenkei() != messageSuperUser">設定を開く</a>
          </div>
        </div>
      </div>
      <div class="header-menu">
        <button class="button is-primary -right-8px" @click="changeModalTask(true)" :disabled="isTaskList">タスク一覧</button>
        <button class="button is-primary -right-8px" @click="scrollSelect(0)">今日</button>
        <button class="button is-primary -right-8px" @click="createRecommendEvent()"><span class="mdi mdi-plus" style="margin-right: 4px;"></span>予定の追加</button>
      </div>
    </div>
    <!-- カレンダー タスク予定リスト -->
    <div class="task-view-wrapper" :class="{'taskview-ontask': isTaskList}">
      <OverlayLoading
        :absoluteFlg="true"
        v-if="isScheduleLoading"/>
      <div class="task-view disp-scroll" id="task" @scroll="scrollRead">
        <!-- 日毎リスト -->
        <div class="task-day" v-for="i in dateList" :key="i" :id="'day-' + i">
          <div class="task-day-box">
            <h2 class="task-day-title" :class="{'-today': i===0}">
              {{getDateTitle(i)}}
            </h2>
          </div>
          <template v-if="scheduleFilter(i).length > 0">
            <div class="task-event"
              @click="eventClick(date)"
              v-for="(date, idx) in scheduleFilter(i)" :key="idx + '-task'"
              :style="getBorder(date)">
              <p class="task-event-by">
                {{getEventBy(date)}}
              </p>
              <p class="task-event-date">
                <span class="mdi mdi-clock-outline -right-4px"></span>
                {{getEventDate(date)}}
              </p>
              <p class="task-event-title">
                <Tooltip :message="date.title">
                  <span class="mdi mdi-calendar-text -right-4px"></span>
                  {{date.title}}
                </Tooltip>
              </p>
              <!-- line -->
              <div class="line"></div>
              <!-- 参加メンバー -->
              <div class="task-event-member" v-if="date.attendees.length > 0">
                <div class="member-status">
                  <span class="mdi mdi-account-location"></span>
                  {{date.attendees.length}}
                </div>
                <div class="member">
                  <Tooltip :message="getMember(date.attendees)">
                    <template v-for="(member, idxMember) in date.attendees">
                      <p :key="idxMember + 'member'" v-if="idxMember < 2">
                        {{member.email}}
                      </p>
                    </template>
                  </Tooltip>
                </div>
              </div>
              <!-- 添付ファイル -->
              <template v-if="isFileAttached(date)">
                <p class="task-event-file">
                  <span class="mdi mdi-file-document" style="margin-right: 4px;"></span>
                  添付ファイルあり
                </p>
              </template>
              <template v-else>
                <p class="task-event-file">
                  <span class="mdi mdi-file-document" style="margin-right: 4px;"></span>
                  添付ファイルなし
                </p>
              </template>
            </div>
          </template>
          <template v-else>
            <p class="no-events">
              <template v-if="!isScheduleLoading">予定がありません。</template>
              <template v-else><span class="mdi mdi-loading mdi-spin"></span></template>
            </p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import OverlayLoading from '@/components/animations/OverlayLoading'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import ModalCreateTask from '@/components/Calendar/organisms/ModalCreateTask'
import ModalSendTask from '@/components/Calendar/organisms/ModalSendTask'
import ModalEditTask from '@/components/Calendar/organisms/ModalEditTask'
import ModalDeleteTask from '@/components/Calendar/organisms/ModalDeleteTask'
import ModalTaskLog from '@/components/Calendar/organisms/ModalTaskLog'
import ModalLinkTrello from '@/components/Calendar/organisms/ModalLinkTrello'
import IslandTask from '@/components/Calendar/organisms/IslandTask'
export default {
  components: {
    OverlayLoading,
    Tooltip,
    ModalCreateTask,
    ModalSendTask,
    ModalEditTask,
    ModalDeleteTask,
    ModalTaskLog,
    ModalLinkTrello,
    IslandTask
  },
  props: {
    authType: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    schedules: {
      type: Array,
      required: true
    },
    eventGroup: {
      type: Array,
      required: true
    },
    taskList: {
      type: Array,
      required: true
    },
    calendarSettings: {
      type: Array,
      required: true
    },
    isSelfCheck: {
      type: Boolean,
      required: true
    },
    isFileChanging: {
      type: Boolean,
      required: true
    },
    isScheduleLoading: {
      type: Boolean,
      required: true
    },
    trelloBoardList: {
      type: Array,
      required: true
    },
    trelloListList: {
      type: Array,
      required: true
    },
    trelloCardList: {
      type: Array,
      required: true
    },
  },
  data () {
    return {
      dateList: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
      editTask: null,
      deleteTask: null,
      sendTask: null,
      fileSelected: null,
      isOpenFileList: false,
      isFilterLoading: false,
      isTaskList: true,
      isModalCreateTask: false,
      isModalEditTask: false,
      isModalDeleteTask: false,
      isModalSendTask: false,
      isModalTaskLog: false,
      isModalLinkTrello: false,
      messageSuperUser: 'スーパーユーザー（他社アカウントにいるため予定作成などしないでください）'
    }
  },
  watch: {
    taskList: {
      handler (val, oldVal) {
        if (this.editTask) {
          this.editTask = this.$_.cloneDeep(
            this.taskList[
              this.$_.findIndex(this.taskList, (
                (obj) => {return obj.pk === this.editTask.pk}
              ))
            ]
          )
        }
      },
      deep: true
    }
  },
  computed: {
    scheduleFilter: function () {
      return function (idx) {
        let ret = []
        let now = new Date()
        now.setDate(now.getDate() + idx)
        for (const s of this.schedules) {
          if (s.className) {
            if (s.className.replace('class-', '') === this.user.userHash && this.isSelfCheck) {
              let start = new Date(s.start)
              let end = new Date(s.end)
              if ( start.getFullYear() <= now.getFullYear()
                  &&
                  start.getMonth() <= now.getMonth()
                  &&
                  start.getDate() <= now.getDate()
                  &&
                  end.getFullYear() >= now.getFullYear()
                  &&
                  end.getMonth() >= now.getMonth()
                  &&
                  end.getDate() >= now.getDate()
                ) {
                  ret.push(s)
              }
            } else {
              for (const setting of this.calendarSettings) {
                if (s.className.replace('class-', '') === setting.calendar_user && setting.is_check) {
                  let start = new Date(s.start)
                  let end = new Date(s.end)
                  if ( start.getFullYear() <= now.getFullYear()
                      &&
                      start.getMonth() <= now.getMonth()
                      &&
                      start.getDate() <= now.getDate()
                      &&
                      end.getFullYear() >= now.getFullYear()
                      &&
                      end.getMonth() >= now.getMonth()
                      &&
                      end.getDate() >= now.getDate()
                    ) {
                      ret.push(s)
                  }
                }
              }
            }
          }
        }
        return ret
      }
    }
  },
  mounted () {
    this.scrollSelect(0)
  },
  methods: {
    changeModalTask (flg) {
      this.isTaskList = flg
    },
    scrollRead (e) {
      if (this.schedules.length === 0) return
      if (e.target.scrollTop === 0) {
        let now = new Date()
        let target = this.dateList[0]
        now.setDate(now.getDate() + target)
        this.$emit('changeTaskSchedules', now, 'forward')
        for (let i = 0; i < 7; i++) {
          this.dateList.unshift(target - i - 1)
        }
        this.scrollSelect(target)
      } else if (e.target.scrollTop >= e.target.scrollHeight - 700) {
        let now = new Date()
        let target = this.dateList[this.dateList.length - 1]
        now.setDate(now.getDate() + target)
        this.$emit('changeTaskSchedules', now, 'backward')
        for (let i = 0; i < 7; i++) {
          this.dateList.push(target + i + 1)
        }
        this.scrollSelect(target)
      }
    },
    scrollSelect (i) {
      setTimeout(() => {
        let scrollHeight = document.getElementById("day-" + i).offsetTop
        document.getElementById("task").scrollTop = scrollHeight
      }, 100)
    },
    getDateTitle (i) {
      let now = new Date()
      now.setDate(now.getDate() + i)
      return now.getFullYear() + '年 ' + (now.getMonth() + 1) + '月 ' + now.getDate() + '日'
    },
    getBorder (event) {
      return {
        'border': 'solid 1.5px ' + event.backgroundColor
      }
    },
    getEventBy (event) {
      let name = 'メンバー'
      for (const user of this.users) {
        if (user.user_hash === event.className.replace('class-', '')) {
          name = user.username
        }
      }
      return name + 'の予定'
    },
    getEventDate (event) {
      let start = new Date(event.start)
      let end = new Date(event.end)
      return ('00' + start.getHours()).slice(-2) + ':' + ('00' + start.getMinutes()).slice(-2) + ' - ' +
        ('00' + end.getHours()).slice(-2) + ':' + ('00' + end.getMinutes()).slice(-2)
    },
    isFileAttached (event) {
      let flg = false
      for (const e of this.eventGroup) {
        if (e.calendar_id === event.id) flg = true
      }
      return flg
    },
    getMember (member) {
      let text = ''
      for (const m of member) {
        text += m.email + '\n'
      }
      return text
    },
    getRenkei () {
      // スーパーユーザーの場合は他社のアカウント連携状況が見れるように表示しておく
      if (this.user.isAgent && this.user.companyID != '32217bf93d824aec3888413722f41a91') {
        return this.messageSuperUser
      } else if (this.authType === 'google') {
        return 'Googleカレンダーと連携済'
      } else if (this.authType === 'cybozu') {
        return 'サイボウズオフィスと連携済'
      } else if (this.authType === 'garoon') {
        return 'ガルーンと連携済'
      } else if (this.authType === 'msoffice') {
        return 'Office365と連携済'
      } else if (this.authType === 'gsession') {
        return 'Group Sessionと連携済'
      } else if (this.authType === 'lineworks') {
        return 'LINE WORKSと連携済'
      } else if (this.authType === 'nolinkage') {
        return '連携なしで利用中'
      }
    },
    openSettings () {
      this.$emit('openSettings')
    },
    eventClick (info) {
      let infoData = {}
      infoData.event = info
      infoData.event.extendedProps = info
      infoData.event.eventFileRef = this.eventGroup
        .filter(e => e.calendar_id === info.id)
        .map(v => v.event_file_ref)
      this.$emit('eventClick', infoData)
    },
    createRecommendEvent (info) {
      this.$emit('createRecommendEvent', info)
    },
    changeCreateTaskView (flg) {
      this.isModalCreateTask = flg
    },
    changeEditTaskView (data) {
      if (data.flg) {
        this.editTask = this.$_.cloneDeep(data.task)
      } else {
        this.editTask = null
      }
      this.isModalEditTask = data.flg
    },
    changeDeleteTaskView (data) {
      if (data.flg) {
        this.deleteTask = data.task
      } else {
        this.deleteTask = null
      }
      this.isModalDeleteTask = data.flg
    },
    changeModalTaskLog (flg) {
      this.isModalTaskLog = flg
    },
    changeModalLinkTrello (flg) {
      this.isModalLinkTrello = flg
      this.$store.dispatch('task/isBoard', false)
    },
    createUserTask (data) {
      this.$emit('createUserTask', data)
    },
    updateUserTask (data) {
      this.$emit('updateUserTask', data)
    },
    deleteUserTask (data) {
      this.$emit('deleteUserTask', data)
    },
    createEvent (data) {
      this.$emit('createEvent', data)
    },
    createUserTaskFile (data) {
      this.$emit('createUserTaskFile', data)
    },
    deleteUserTaskFile (pk) {
      this.editTask.user_task_file.splice(
        this.$_.findIndex(this.editTask.user_task_file, ((obj) => {return obj.pk === pk})),
        1
      )
      this.$emit('deleteUserTaskFile', pk)
    },
    changeSendTaskView (data) {
      if (data.flg) {
        this.sendTask = data.task
      } else {
        this.sendTask = null
      }
      this.isModalSendTask = data.flg
    },
    sendUserTask (task, members) {
      this.$emit('sendUserTask', task, members)
    },
    updateUserTaskLog (log) {
      this.$emit('updateUserTaskLog', log)
    },
    createLinkTrelloAPI (data) {
      this.$store.dispatch('task/createLinkTrelloAPI', data)
    },
    createLinkTrelloBoard ({data, data2}) {
      this.$store.dispatch('task/createLinkTrelloBoard', {data, data2})
      .then((d) => {
        this.$store.dispatch('task/getTrelloList')
        this.$store.dispatch('task/getTrelloBoard')
        this.$store.dispatch('task/getUserTask')
        .then((d) => { 
           this.$store.dispatch('task/getTrelloLoading', false)
           this.isModalLinkTrello = false
        })
      })
    },
  }
}
</script>

<style lang='scss' scoped>
.main-body {
  height: calc(100vh - 0px);
  width: -webkit-fill-available;
  overflow: hidden;
  position: relative;
  margin-right: 2px;
}
.main-body::-webkit-scrollbar {
  width:  6px;
  height: 6px;
  visibility: hidden;
}
.header-ontask {
  width: calc(100% - 328px) !important;
  margin: 10px 40px 10px 288px !important;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px 10px 40px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
  .header-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5px;
  }
}
.taskview-ontask {
  width: calc(100% - 248px) !important;
  height: calc(100% - 248px) !important;
  margin-left: 248px !important;
  overflow: auto;
}
.task-view-wrapper {
  position: relative;
  height: calc(100% - 150px);
  width: 100%;
  margin-left: 0px;
  .task-view {
    padding: 24px;
    height: 100%;
    width: 100%;
    text-align: left;
    .task-day {
      margin-top: 16px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .task-day-box {
        width: 100%;
        margin-bottom: 16px;
        .task-day-title {
          padding: 8px 16px;
          font-size: 20px;
          font-weight: 600;
          color:#fff;
          background:#AA0066;
        }
        .-today {
          border: double 4px #FFF;
        }
      }
      .task-event {
        width: 280px;
        height: 191px;
        padding: 16px;
        margin: 8px;
        border: solid thin #ccc;
        border-radius: 8px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        cursor: pointer;
        /deep/ .tooltip {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .task-event-by {
          color: #666;
          font-size: 12px;
        }
        .task-event-date {
          font-weight: 600;
        }
        .task-event-title {
          font-weight: 600;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .line {
          width: 100%;
          height: 0.5px;
          border-bottom: dotted 4px #ccc;
          margin: 1px;
        }
        .task-event-member {
          display: flex;
          align-items: center;
          width: 100%;
          .member-status {
            width: 40px;
          }
          .member {
            width: calc(100% - 40px);
            p {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
    .no-events {
      padding: 12px;
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Calendar/TaskView.vue